import loggerMiddleware from "redux-logger";
import { Persistor, persistStore } from "redux-persist";
import { applyMiddleware, compose, createStore, Store } from "redux";

import { IS_DEV } from "../constants/AppConstants";
import { AppStoreState, rootReducer } from "./RootReducer";
import { injectStore } from "../api/BaseApi";

export type AppStore = Store<AppStoreState>;

export interface StoreProps {
  readonly store: AppStore;
  readonly persistor: Persistor;
}

export function configureStore(): StoreProps {
  const store = createStore<AppStoreState, any, any, any>(
    rootReducer,
    IS_DEV ? compose(applyMiddleware(loggerMiddleware)) : undefined,
  );

  injectStore(store);

  const persistor = persistStore(store);

  return {
    store,
    persistor,
  };
}
